import React, { Fragment } from 'react';
import factory from 'components/Icons/factory';

export const Trash = factory(
  'Trash',
  <Fragment>
    <g id="Group_10" data-name="Group 10" transform="translate(-3.751 -5.54)">
      <path
        id="Path_31"
        data-name="Path 31"
        d="M87.905,14.658A4.458,4.458,0,0,0,83.447,10.2H51.054A4.458,4.458,0,0,0,46.6,14.658v11.59H14.5v8.916h7.875v72.811A20.5,20.5,0,0,0,42.881,128.48H91.917a20.357,20.357,0,0,0,20.357-20.357V35.164H120V26.248h-32.1ZM51.351,100.99H42.436V50.469h8.916Zm20.357,0H62.793V50.469h8.916Zm7.281-74.742H55.512V19.116H78.989ZM92.066,50.469V100.99H83.15V50.469Z"
        transform="translate(0 0)"
      />
    </g>
    <rect
      id="Rectangle_18"
      data-name="Rectangle 18"
      width="128"
      height="128"
      fill="none"
    />
  </Fragment>
);

export default Trash;
